// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import rem from './rem'
import store from './store'
import cookie from './libs/cookie'

rem.init(window)
Vue.config.productionTip = false

Vue.directive('title', {
	inserted: function(el, bind) {
		document.title = bind.value
	}
})
Vue.directive('focus', {
	inserted: function(el, bind) {
		if(bind.value){el.focus();}
	}
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})

window.toast = function(txt,callback) {
	$('body').append('<div class="toast">' + txt + '</div>')
	setTimeout(function() {
		$('.toast').remove();
		if(callback){
			callback();
		}
	}, 2000)
}
window.querystr = function(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	var r = window.location.search.substr(1).match(reg);
	if(r != null) return unescape(r[2]);
	return null;
}


//var xiaoxiongChannel = [731100001,731100002,731300001]
//var channelid = querystr('channelid')||cookie.get('channelid')||0;
//if(xiaoxiongChannel.indexOf(channelid-0) != -1){
//	cookie.set('isxiaoxiong', true, {
//		domain: 'qxiu.com',
//		encode: true
//	})
//	console.log(1111)
//	cookie.set('oemid',43, {domain: 'qxiu.com',encode: true})
//	sessionStorage.setItem('isxiaoxiong',true)
//}else{
//	cookie.set('isxiaoxiong', false, {
//		domain: 'qxiu.com',
//		encode: true
//	})
//	sessionStorage.setItem('isxiaoxiong',false)
//}





// WEBPACK FOOTER //
// ./src/main.js